// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/components/DispatchFilterPanel.js
// =============================================================================

import React from "react";

import {
  Search
} from "lucide-react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function DispatchFilterPanel({

  filters,

  onChange,

  onApply

}) {

  return (

    <div style={styles.filterCard}>


      {/* ================================================================ */}
      {/* FILTER ROW */}
      {/* ================================================================ */}
      <div style={styles.filterRow}>


        {/* STATUS */}
        <div style={styles.filterGroup}>

          <label style={styles.label}>
            Dispatch Status
          </label>

          <select
            value={filters.status}
            onChange={(e) =>
              onChange(
                "status",
                e.target.value
              )
            }
            style={styles.select}
          >

            <option value="">
              ALL
            </option>

            <option value="DRAFT">
              Draft
            </option>

            <option value="SUBMITTED">
              Submitted
            </option>

            <option value="APPROVED">
              Approved
            </option>

          </select>

        </div>


        {/* SEARCH */}
        <div
          style={{
            ...styles.filterGroup,
            flex: 1
          }}
        >

          <label style={styles.label}>
            Search Packing List
          </label>

          <div style={styles.searchBox}>

            <Search size={16} />

            <input
              type="text"
              placeholder={
                "Search by packing list, vehicle or driver"
              }
              value={filters.search}
              onChange={(e) =>
                onChange(
                  "search",
                  e.target.value
                )
              }
              style={styles.searchInput}
            />

          </div>

        </div>


        {/* ACTION */}
        <div style={styles.actionWrap}>

          <button
            style={styles.applyBtn}
            onClick={onApply}
          >
            Apply Filters
          </button>

        </div>

      </div>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  filterCard: {

    background: "#fff",

    borderRadius: 12,

    padding: 16,

    marginBottom: 20,

    boxShadow:
      "0 1px 3px rgba(0,0,0,0.08)"
  },

  filterRow: {

    display: "flex",

    gap: 16,

    flexWrap: "wrap",

    alignItems: "end"
  },

  filterGroup: {

    display: "flex",

    flexDirection: "column",

    minWidth: 240
  },

  label: {

    fontSize: 12,

    marginBottom: 6,

    color: "#374151",

    fontWeight: 600
  },

  select: {

    height: 38,

    borderRadius: 8,

    border: "1px solid #d1d5db",

    padding: "0 10px",

    background: "#fff"
  },

  searchBox: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    border: "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 10px",

    height: 38,

    background: "#fff"
  },

  searchInput: {

    border: "none",

    outline: "none",

    width: "100%"
  },

  actionWrap: {

    display: "flex",

    alignItems: "end"
  },

  applyBtn: {

    background: "#2563eb",

    color: "#fff",

    border: "none",

    borderRadius: 8,

    padding: "10px 18px",

    cursor: "pointer",

    fontWeight: 600
  }
};